import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import EnderecoForm from '../../../components/EnderecoForm';
import ContatoForm from '../../../components/ContatoForm';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    subtite: {
        marginTop: theme.spacing(3),
    },
    formControl: {
        minWidth: 120,
    },
}));

export default function CompletarCadastroForm(props) {
    const classes = useStyles();

    onsubmit = (event) => {
        event.preventDefault()
        props.onSubmit()
      }

    return (
        <Container component="main" maxWidth="sm">
            <div className={classes.paper}>
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="cpfcnpj"
                                label="CPF/CNPJ"
                                name="cpfcnpj"
                                type="text"
                                value={props.documento}
                                autoFocus
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                autoComplete="fname"
                                name="name"
                                variant="outlined"
                                required
                                fullWidth
                                id="name"
                                label="Nome"
                                value={props.nome}
                                disabled
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.subtite} variant="subtitle1">
                                Localização
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <EnderecoForm />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.subtite} variant="subtitle1">
                                Contato
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <ContatoForm />
                        </Grid>

                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Salvar
                    </Button>
                </form>
            </div>
        </Container>
    );
}